module.exports = __webpack_public_path__ + "static/media/179-ireland.efad590a.svg";